import axios from "axios";

/**
 * Update a road recording with any fields.
 * @param {string} baseUrl - API base url.
 * @param {string} recordId - The recording's id.
 * @param {object} updates - Object with fields to update.
 */
export async function updateRoadRecording(baseUrl, recordId, updates) {
  try {
    const response = await axios.put(
      `${baseUrl}/admin/updateRoadRecording`,
      { recordId, updates }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating road recording:", error);
    return { error: error?.response?.data?.error || error.message };
  }
}
